import { useMutation } from "@tanstack/react-query";
import { Button, Typography } from "antd";
import { AxiosError } from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import ROUTES from "shared/routes";
import { Input } from "shared/ui/Input";
import { login } from "../api";

export const AuthForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [phone, setPhone] = useState<string>("");
  const [error, setError] = useState<string>("");

  const { mutate: sendPhone, isPending: isSendPhonePending } = useMutation({
    mutationFn: (phoneNumber: string) =>
      login({ phone: phoneNumber.replace(/\D/g, "") }),
    onSuccess(response) {
      navigate(`${ROUTES.CODE}?${searchParams.toString()}`, {
        state: { phone, token: response.data?.token },
      });
    },
    onError(error: AxiosError<{ message?: string }>) {
      if (!error) return setError("");

      if (error.status === 404) {
        return setError(t("auth.phone_number_undefined"));
      }
      return setError(error?.response?.data?.message || error?.message || t("auth.phone_number_error"));
    },
  });

  return (
    <div>
      <Typography.Title level={3}>{t("auth.title")}</Typography.Title>
      <div>
        <p>{t("auth.text")}</p>

        <Input
          label={t("auth.phone_number")}
          mask="+7 (999) 999 99 99"
          name="additional-phone"
          type="tel"
          placeholder="+ 7"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        {!!error && (
          <Typography.Text
            style={{ marginBottom: 16, display: "block" }}
            type="danger"
          >
            {error}
          </Typography.Text>
        )}

        <Button
          block
          type="primary"
          disabled={phone.replace(/\D/g, "").length < 11}
          onClick={() => sendPhone(phone)}
          loading={isSendPhonePending}
        >
          {t("auth.get_code")}
        </Button>
      </div>
    </div>
  );
};
